module.exports = __webpack_public_path__ + "img/screenshot-vrl.5cc5e45c.png";